// JsFromRoutes CacheKey 46d6f41f62354d26dc7641f9d0b35669
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  onboard: /* #__PURE__ */ definePathHelper('get', '/brokers/employers/:employer_id/employees/:employee_id/onboard'),
  terminateView: /* #__PURE__ */ definePathHelper('get', '/brokers/employers/:employer_id/employees/:employee_id/terminate'),
  terminate: /* #__PURE__ */ definePathHelper('post', '/brokers/employers/:employer_id/employees/terminate'),
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/employers/:employer_id/employees'),
  create: /* #__PURE__ */ definePathHelper('post', '/brokers/employers/:employer_id/employees'),
  update: /* #__PURE__ */ definePathHelper('patch', '/brokers/employers/:employer_id/employees/:id'),
}
